import { cmp } from "./cmp.js";

export function sorted<T extends number[] | string[]>(list: T): T {
	list = [...list] as T;
	if (list[0] !== undefined) {
		list.sort(cmp(list[0]));
	}
	return list;
}
